import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosHttp } from '../AxiosWrapper';
import AuthenticationModalView from '../views/dss/AuthenticationModalView';
import { localdb } from '../utils/CommonUtil';
import { SignInSignUpProvider } from './SignInSignUpProvider';
import { HttpStatusCode } from 'axios';
import ProgressView from '../views/common/ProgressView';
import ProgressIndicator from '../components/ProgressIndicator';
import { usePooling } from '../hooks/usePooling';

const AuthenticationContext = createContext({});
const excluded_redirected_path = ["/dss"]

const AuthenticationProvider = ({ children }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [inProgress, setInProgress] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const openLoginModal = () => setShowLoginModal(true);
    const closeLoginModal = () => setShowLoginModal(false);


    const urlParams = new URLSearchParams(window.location.search);
    const merchantToken = urlParams.get("m_token");
    const merchantAuthToken = urlParams.get("ma_token");

    useEffect(() => {
        if (merchantToken && merchantAuthToken) {
            setInProgress(true);
            axiosHttp.post("/api/pub/user/v1/addUser?m=1", { m_token: merchantToken, ma_token: merchantAuthToken })
                .then((res) => {
                    if (res.data.status === HttpStatusCode.Ok) {
                        let data = res.data.content;
                        data.user.loggedOn = Date.now();
                        localdb.put("userData", JSON.stringify(data));
                        setUserData(getUser());
                    }
                }).catch((err) => { })
                .then(() => {
                    setInProgress(false);
                    const url = new URL(window.location.href);
                    if (url.searchParams.get("m_token")) {
                        url.searchParams.delete("m_token");
                    }
                    if (url.searchParams.get("ma_token")) {
                        url.searchParams.delete("ma_token");
                    }
                    window.history.replaceState({}, document.title, url.toString());
                })
        }
    }, [])


    useEffect(() => {
        sendHeartBeat();
        handleResponseErrors(openLoginModal, navigate);
    }, []);


    const sendHeartBeat = async () => {
        if (isLoggedIn()) {
            axiosHttp.post("/api/pub/user/v1/blink")
                .then((res) => {

                }).catch((err) => { })
                .then(() => {

                })
        }
    }
    usePooling(() => {
        sendHeartBeat();
    }, 45000);

    const login = () => {
        openLoginModal();
    }

    const logedInSuccess = (data, redirect = true) => {
        if (showLoginModal) {
            closeLoginModal();
        }
        //adding loggedIn time
        data.user.loggedOn = Date.now();
        localdb.put("userData", JSON.stringify(data));

        setUserData(data.user);
        sendHeartBeat();
    };

    const isLoggedIn = () => {
        let user = localdb.get("userData") && JSON.parse(localdb.get("userData")).user;
        if (!user || !user.loggedOn) {
            return false;
        }
        return true;
        //return (Date.now() - user.loggedOn) < parseInt(user.sessionExpiredIn);
    }

    const getUser = () => {
        if (localdb.get("userData")) {
            return JSON.parse(localdb.get("userData")).user;
        }
    }

    const updateUser = (data) => {
        let userData = JSON.parse(localdb.get("userData"));
        if (data.displayName) {
            userData.user.displayName = data.displayName
        }
        localdb.put("userData", JSON.stringify(userData));
        setUserData(userData.user);
    }

    const logout = () => {
        axiosHttp.post("/api/dss/v1/signOut")
            .then((res) => {
            }).catch((err) => { })
            .then((res) => {
                clearUser();
                navigate("/");
            })
    };

    const clearUser = () => {
        localdb.remove("userData");
        setUserData(null);
    }

    const [userData, setUserData] = useState(getUser());

    const memoObj = useMemo(() => ({ login, logedInSuccess, logout, isLoggedIn, getUser, userData, closeLoginModal, updateUser }),
        [userData, isLoggedIn]);
    return (
        <AuthenticationContext.Provider value={memoObj}>
            {children}
            {showLoginModal && <SignInSignUpProvider> <AuthenticationModalView open={showLoginModal} close={closeLoginModal} /> </SignInSignUpProvider>}
            {inProgress && <ProgressIndicator open={inProgress} />}
        </AuthenticationContext.Provider>
    )
}
AuthenticationProvider.propTypes = {
    children: PropTypes.string.isRequired,
};

const useAuthentication = () => {
    return useContext(AuthenticationContext);
}

export { AuthenticationProvider, useAuthentication };

const setRedirectPath = (redirectPath) => {
    let pathArr = excluded_redirected_path.filter(path => redirectPath.startsWith(path));
    if (!pathArr || pathArr.length === 0) {
        localdb.put("redirectPath", redirectPath);
    }

}

const getRedirectPath = (path) => {
    return localdb.get("redirectPath");
}

const handleResponseErrors = (openLoginModal, navigate) => {
    const responseInterceptor = axiosHttp.interceptors.response.use(response => {
        return response

    }, (error) => {
        if (error.status === 401) {//authentication
            openLoginModal();
        } else if (error.status === 403) {//Forbidden force logout
            navigate("/error/inactive");
        } else if (error.status === 404) {//No Found
        } else if ("ERR_NETWORK" === error.code) {
        } else if (error.response && error.response.status === 503) {//Service unavailable
            //underMaintenanceModal();
        } else {
            // toggleError(true, error);// all other internal errors
            //errorModal();
        }
        return Promise.reject(error)
    })

    return () => {
        axiosHttp.interceptors.response.eject(responseInterceptor);
    }
}

